import React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";

import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

function CustomSplitButton({ anchorRef, handleOpen, handleClick, title }) {
  return (
    <ButtonGroup
      variant="contained"
      color="primary"
      ref={anchorRef}
      aria-label="split button"
      sx={{ margin: "auto" }}
    >
      <Button
        id={`button${title}`}
        startIcon={<AddIcon />}
        onClick={handleClick}
      >
        {title}
      </Button>
      <Button
        id={"buttonChangeType"}
        color="primary"
        size="small"
        aria-controls={"split-button"}
        aria-expanded={"true"}
        aria-label="select question type"
        aria-haspopup="menu"
        onClick={handleOpen}
      >
        <ArrowDropDownIcon />
      </Button>
    </ButtonGroup>
  );
}

export default CustomSplitButton;
